<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Edit Link</modal-header>
        </div>
        <div>
          <form-group>
            <field name="Name" :value="name" v-model="name" />
          </form-group>
        </div>
      <div v-if="allowEditPassword">
        <a href="javascript:;" @click="enableEditPassword">{{ isPasswordEditing? 'Cancel edit password' : 'Edit password'}}</a>
        <form-group v-if="isPasswordEditing">
          <field name="Password" :value="password" v-model="password" />
          <small class="password-error" v-if="passwordError">
            {{passwordError}}
          </small>
          <small >
            <a href="javascript:;" @click="generatePassword">Auto generate password</a>
          </small>
        </form-group>
      </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import {modalMixin} from '@/mixins/modalMixin'
import {linkMixin} from '@/mixins/linkMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_edit_link',
  mixins: [modalMixin, linkMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String,
    linkType: String,
    allowEditPassword: { type: Boolean, default: false }
  },
  data: () => ({
    name: '',
    password: '',
    isPasswordEditing: false,
    passwordError: null
  }),
  mounted () {
    this.name = this.field
  },
  computed: {},
  methods: {
    confirm () {
      if (this.isPasswordEditing && this.password.trim().length < 8) {
        this.passwordError = 'Password is required and min length is 8 characters'
        const timerId = setTimeout(() => {
          clearTimeout(timerId)
          this.passwordError = null
        }, 8000)
        return
      }
      this.startLoading()
      const data = {
        id: this.confirmId,
        name: this.name,
        password: this.allowEditPassword && this.isPasswordEditing ? this.password : null
      }
      this.updateLink(data).then(() => {
        this.addNotification('success', 'Link updated.')
        this.getLinks(this.linkType).then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    },
    enableEditPassword () {
      this.isPasswordEditing = !this.isPasswordEditing
      if (!this.isPasswordEditing) {
        this.password = ''
      }
    },
    generatePassword () {
      const length = 8
      const charset = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let retVal = ''
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      this.password = retVal
    }
  },
  watch: {
    field: function () {
      this.name = this.field
    }
  }
}
</script>

<style lang="scss">
.password-error{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/links/modal-edit-link.vue